import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-tracker',
    templateUrl: './tracker.component.html'
})
export class TrackerComponent implements OnInit {


    constructor() {

    }

    ngOnInit() {
    }

}